export const init = () => {
    const closeSiblingAccordions = (item) => {
        const parent = item?.parentNode;
        const siblings = parent?.querySelectorAll(':scope > *');
        if (siblings) {
            siblings.forEach((sibling) => {
                if (sibling !== item) {
                    sibling?.querySelector('.g-accordion__header')?.classList.remove('active');
                    sibling?.querySelector('.g-accordion__content')?.removeAttribute('style');
                    sibling?.classList.remove('active');
                }
            });
        }
    };

    const initializeAccordions = (container) => {
        const accordions = container.querySelectorAll('.g-accordion:not([data-initialized="true"])');
        accordions.forEach((item) => {
            item.dataset.initialized = true;
            const button = item.querySelector('.g-accordion__header');
            const content = item.querySelector('.g-accordion__content');

            if (item.classList.contains('active')) {
                button.classList.add('active');
                content.style.maxHeight = `${content.scrollHeight}px`;
            }

            button.addEventListener('click', () => {
                if (item.classList.contains('g-accordion-single-click')) {
                    closeSiblingAccordions(item);
                }

                button.classList.toggle('active');
                console.log("clicked");
                if (content.style.maxHeight) {
                    content.removeAttribute('style');
                    item.classList.remove('active');
                } else {
                    content.style.maxHeight = `${content.scrollHeight}px`;
                    item.classList.add('active');
                }
            });
        });
    };

    const setupMutationObserver = () => {
        const observer = new MutationObserver((mutationsList) => {
            mutationsList.forEach((mutation) => {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach((node) => {
                        if (node.nodeType === Node.ELEMENT_NODE) {
                            initializeAccordions(node);
                            // Pokud přidaný uzel obsahuje další uzly, které by mohly obsahovat .g-accordion
                            node.querySelectorAll('.g-accordion').forEach((accordion) => {
                                initializeAccordions(accordion);
                            });
                        }
                    });
                }
            });
        });

        observer.observe(document.body, { childList: true, subtree: true });
    };

    // Inicializace všech existujících akordeonů na stránce
    initializeAccordions(document.body);
    // Nastavení MutationObserveru
    setupMutationObserver();
};